import React, { useEffect, useState } from "react";
import axios from "axios";

import { IoIosAddCircleOutline } from "react-icons/io";
import { FaSearch } from "react-icons/fa";
import { LuFileEdit } from "react-icons/lu";
import { FaRegTrashCan } from "react-icons/fa6";
import { GrView } from "react-icons/gr";
import { ImCross } from "react-icons/im";
import Pagination from "../../utils/Pagination";
import {
  createCategory,
  deleteCategory,
  updateCategory,
  fetchCategoryById,
  fetchCategories,
} from "../../services/api";
import AlertMsg from "../../components/AlertMsg/AlertMsg";
import Loading from "../../components/Loading/Loading";
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";

const Category = () => {
  const [category, setCategory] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [newBlockName, setNewBlockName] = useState("");
  const [editBlock, setEditBlock] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [viewBlockDetails, setViewBlockDetails] = useState(null);
  const [blockToDelete, setBlockToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const blocksPerPage = 10;
  const [loading, setLoading] = useState(false);
  const [sortAscending, setSortAscending] = useState(true);

  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    activeStatus: true,
  });
  const [errors, setErrors] = useState({
    name: "",
    activeStatus: "",
  });
  const [alert, setAlert] = useState({ visible: false, message: '', type: '' });
    // Validation function
    const validateForm = () => {
      let formErrors = { name: "", activeStatus: "" };
      let valid = true;
  
      if (formData.name.trim() === "") {
        formErrors.name = "Category is required";
        valid = false;
      }
  
      if (formData.activeStatus === null || formData.activeStatus === undefined) {
        formErrors.activeStatus = "Please select a status";
        valid = false;
      }
  
      setErrors(formErrors);
      return valid;
    };

  const fetchcategory = async () => {
    setLoading(true);
    try {
      const response = await fetchCategories();
      setCategory(response.data);
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchcategory();
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    
    // Reset form data and errors when closing the modal
    if (isModalOpen) {
      setFormData({
        id: 0,
        name: "",
        activeStatus: true,
      });
      setErrors({
        name: "",
        activeStatus: "",
      });
    }
  };

  const toggleViewModal = () => {
    setIsViewModalOpen(!isViewModalOpen);
    setViewBlockDetails(null);
  };

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
    
    // Reset form data and errors when closing the modal
    if (isEditModalOpen) {
      setFormData({
        id: 0,
        name: "",
        activeStatus: true,
      });
      setErrors({
        name: "",
        activeStatus: "",
      });
      fetchcategory();
    }
  };

  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setBlockToDelete(null);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "activeStatus" ? value === "true" : value;
    setFormData({
      ...formData,
      [name]: newValue,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  const handleCancel = () => {
    setFormData({
      id: 0,
      name: "",
      activeStatus: true,
    });
    setIsEditModalOpen(false);
    setIsModalOpen(false);
    setIsEditModalOpen(false);
    setIsDeleteModalOpen(false);
    setBlockToDelete(null);
    setErrors({
      name: "",
      activeStatus: "",
    });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const filteredBlocks = category
  .filter(
    (block) =>
      block.name && block.name.toLowerCase().includes(searchTerm.toLowerCase())
  )
  .sort((a, b) => {
    if (sortAscending) {
      return a.name.localeCompare(b.name); // Ascending order
    } else {
      return b.name.localeCompare(a.name); // Descending order
    }
  });

  const pageCount = Math.ceil(filteredBlocks.length / blocksPerPage);

  const getCurrentPageBlocks = () => {
    const startIndex = currentPage * blocksPerPage;
    const endIndex = startIndex + blocksPerPage;
    return filteredBlocks.slice(startIndex, endIndex);
  };

  const handleAddBlock = async () => {
    const isValid = validateForm();
    if (!isValid) return;
    setIsModalOpen(false);
    setLoading(true);
    try {
      const response = await createCategory(formData);
      console.log(response.data);
      setAlert({ visible: true, message: 'Category added successfully!', type: 'success' });
      handleCancel();
      fetchcategory();
    } catch (error) {
      console.error("Error adding category:", error);
      setAlert({ visible: true, message: 'Error adding category. Please try again.', type: 'error' });
    }  finally {
      setLoading(false);
    }
  };

 

  const handleEditBlock = async (id) => {
    setIsEditModalOpen(false);
    console.log(formData);
    try {
      const response = await fetchCategoryById(id);
      setFormData(response.data);
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error fetching category details:", error);
    }
  };
  console.log(formData);

  const handleSaveEditBlock = async () => {
    if (!validateForm()) {
      return; 
    }
    setIsEditModalOpen(false);
    setLoading(true);
    try {
      const response = await updateCategory(formData.id, formData);
      console.log(response.data);
      setAlert({ visible: true, message: 'Category updated successfully!', type: 'success' });
      handleCancel();
      fetchcategory();
    } catch (error) {
      console.error("Error updating category:", error);
      setAlert({ visible: true, message: 'Error adding category. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteBlock = async () => {
    if (!blockToDelete) return;
setIsDeleteModalOpen(false);
    setLoading(true);
    try {
      await deleteCategory(blockToDelete.id);
      handleCancel();
      setAlert({ visible: true, message: 'Category deleted successfully!', type: 'success' });
      fetchcategory();
    } catch (error) {
      console.error("Error deleting category:", error);
      setAlert({ visible: true, message: 'Error deleting category. Please try again.', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteIconClick = (block) => {
    setBlockToDelete(block);
    setIsDeleteModalOpen(true);
  };
  const handleSortByName = () => {
    setSortAscending(!sortAscending); // Toggle sorting order
  };

  return (
    <div className="houseState">
       {loading && <Loading/>}
      {!loading && (
      <div className="houseState-container box-shadow">
      {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}
        <div className="container-head p-15">
          <h2>Category</h2>
          <div className="btns">
            <span className="add-btn" onClick={toggleModal}>
              <IoIosAddCircleOutline />
              <p>Add category</p>
            </span>
          </div>
        </div>
        <div className="table-filters">
          <div className="search-filter">
            <label htmlFor="searchName">
              <FaSearch />
            </label>
            <input
              type="text"
              id="searchName"
              placeholder="Search by category"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
        <div className="houseState-content" style={{ overflowX: "auto" }}>
          <div className="table-container">
            <table className="custom-table">
              <thead>
                <tr>
                <th onClick={handleSortByName} style={{ cursor: 'pointer' }}>
  Category{sortAscending ? <RiSortAlphabetAsc /> : <RiSortAlphabetDesc />}
</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {getCurrentPageBlocks().length > 0 ? (
                  getCurrentPageBlocks().map((item) => (
                    <tr key={item.id}>
                      <td className="text-left">{item.name}</td>
                      <td className="text-center">
                        <p
                          className={item.activeStatus ? "active" : "inactive"}
                        >
                          {item.activeStatus ? "Active" : "Inactive"}
                        </p>
                      </td>
                      <td className="text-center">
                        {/* <GrView onClick={() => handleViewBlock(item.id)} />{" "} */}
                        <LuFileEdit onClick={() => handleEditBlock(item.id)} />{" "}
                        <FaRegTrashCan
                          onClick={() => handleDeleteIconClick(item)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No blocks found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <Pagination
            currentPage={currentPage}
            pageCount={pageCount}
            setCurrentPage={setCurrentPage}
          />
          </div>
          
        </div>
      </div>
 )}
      {/* Add Block Modal */}
      {isModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Add Name</h3>
              <span className="close-icon" onClick={toggleModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
            <div className={`add-form ${errors.name ? "error" : ""}`}>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  name="name"
                  maxLength={50}
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "input-error" : ""}
                />
               
              </div>
              <div className="btn-container">
                <div className="addforbtns">
                  <div className="btn-cancel" onClick={toggleModal}>
                    Cancel
                  </div>
                  <button
                    className="btn"
                    onClick={handleAddBlock}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Block Modal */}
      {isEditModalOpen && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>Edit Name</h3>
              <span className="close-icon" onClick={toggleEditModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
            <div className="add-form">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  maxLength={50}
                  value={formData.name}
                  onChange={handleInputChange}
                  className={errors.name ? "input-error" : ""}
                />
               
              </div>
              <div className="add-form">
                <label htmlFor="activeStatus">Active Status:</label>
                <div className="custom-radio-group">
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={true}
                      checked={formData.activeStatus === true}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Active
                  </label>
                  <label className="custom-radio-label">
                    <input
                      type="radio"
                      name="activeStatus"
                      value={false}
                      checked={formData.activeStatus === false}
                      onChange={handleInputChange}
                      className="custom-radio-input"
                    />
                    Inactive
                  </label>
                  {errors.activeStatus && (
                    <span className="error-message">{errors.activeStatus}</span>
                  )}
                </div>
              </div>
              <div className="btn-container">
                <div className="addforbtns">
                  <div className="btn-cancel" onClick={toggleEditModal}>
                    Cancel
                  </div>
                  <button
                    className="btn"
                    onClick={handleSaveEditBlock}
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      )}
      {/* View Block Modal */}
      {isViewModalOpen && viewBlockDetails && (
        <div className="screen">
          <div className="screen-container">
            <div className="add-form-head">
              <h3>View Category Details</h3>
              <span className="close-icon" onClick={toggleViewModal}>
                <ImCross />
              </span>
            </div>
            <div className="add-forms">
              <div className="add-form">
                <label htmlFor="name"> Name</label>
                <input
                  type="text"
                  id="name"
                  value={viewBlockDetails.name}
                  readOnly
                />
              </div>
              <div className="add-form">
                <label>Status</label>
                <input
                  type="text"
                  value={viewBlockDetails.activeStatus ? "Active" : "Inactive"}
                  readOnly
                />
              </div>
              <div className="btn-container">
                <div className="addforbtns">
                  <div className="btn-cancel" onClick={toggleViewModal}>
                    Close
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isDeleteModalOpen && (
        <div className="screen">
          <div className="screen-container delete-popup">
            <h2>Are you sure you want to delete?</h2>
            <p>This action is permanent and cannot be undone.</p>

            <button
              onClick={handleDeleteBlock}
              className="delete btn"
              disabled={isLoading}
            >
              {isLoading ? "Deleting..." : "Yes, Delete"}
            </button>
            <button className="btn-cancel" onClick={toggleDeleteModal}>
              No, Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Category;
